

import React from "react";
import { Row, Col, Tabs, Tooltip } from "antd";
import { FaTimes } from "react-icons/fa";
import { MdEventSeat } from "react-icons/md";

const { TabPane } = Tabs;
const AirplaneSeat = ({
    totalSelectedTravellers,
    rowsByFlight,
    legends,
    selectedSeats,
    onClick,
    skipSeats
}) => {

    const getSeatStyle = (seat, flightKey) => {
        const isSelected = (selectedSeats[flightKey] || []).find((s) => s.Code === seat.Code);

        return {
            backgroundColor: seat.ColorCode,
            border: isSelected ? "2px solid #00378F" : "1px solid #999",
            borderRadius: "10px 10px 4px 4px",
            width: "30px",
            height: "30px",
            margin: "4px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "12px",
            fontWeight: "600",
            color: seat.Available ? "#000" : "#fff",
            cursor: seat.Available || isSelected ? "pointer" : "not-allowed",
            boxShadow: isSelected
                ? "0 0 6px rgba(0, 55, 143, 0.6)"
                : "0 2px 4px rgba(0,0,0,0.2)",
            transition: "all 0.2s ease-in-out",
        };
    };

    const renderSeatSection = (rows, flightKey) => {
        return (
            <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", marginBottom: 0 }}>
                    <div style={{ width: 30 }} />
                    {rows.map((row) => (
                        <div
                            key={`top-${row.RowNumber}`}
                            style={{
                                width: 30,
                                height: 30,
                                margin: "4px",
                                textAlign: "center",
                                fontWeight: "600",
                            }}
                        >
                            {row.RowNumber}
                        </div>
                    ))}
                    <div style={{ width: 30 }} />
                </div>

                {["A", "B", "C", "D", "E", "F"].map((letter) => (
                    <React.Fragment key={letter}>
                        {letter === "D" && (
                            <div style={{ margin: "6px 0", fontStyle: "italic", color: "#666" }}>
                                &nbsp;&nbsp;&nbsp;
                                &nbsp;&nbsp;&nbsp;
                                &nbsp;&nbsp;&nbsp;
                                &nbsp;&nbsp;&nbsp;
                            </div>
                        )}

                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginBottom: 4 }}>
                            <div style={{ width: 30, textAlign: "center", fontWeight: "600" }}>
                                {letter}
                            </div>

                            {rows.map((row) => {
                                const seat = row.Seats.find((s) => s.SeatNo === letter);
                                if (!seat) {
                                    return (
                                        <div
                                            key={`${letter}-${row.RowNumber}`}
                                            style={{ width: 30, height: 30, margin: 6 }}
                                        />
                                    );
                                }

                                const isSelected = (selectedSeats[flightKey] || []).find(
                                    (s) => s.Code === seat.Code
                                );

                                return (
                                    <Tooltip
                                        key={seat.Code}
                                        title={
                                            <>
                                                {seat?.ColorName === "No Seat" ? (
                                                    <div><b>Seat Info Not Available</b></div>
                                                ) : seat?.ColorName === "Booked" ? (
                                                    <div><b>Booked</b></div>
                                                ) : (
                                                    <>
                                                        <div><b>{seat.Code} | {seat.SeatCategory} | ₹{seat.Price}</b></div>
                                                        <div><b>Status :</b> {seat.Available ? "Available" : "Booked"}</div>
                                                    </>
                                                )}

                                            </>
                                        }
                                        placement="top"
                                    >
                                        <div
                                            style={getSeatStyle(seat, flightKey)}
                                            onClick={() => onClick(seat, flightKey)}
                                        >
                                            {seat.ColorName === "No Seat" ? (
                                                <FaTimes style={{ color: "#fff", fontSize: "20px" }} />
                                            ) : isSelected ? (
                                                "✔"
                                            ) : ""}
                                            {/* {isSelected ? "✔" : ""} */}
                                        </div>
                                    </Tooltip>
                                );
                            })}

                            <div style={{ width: 30, textAlign: "center", fontWeight: "600" }}>
                                {letter}
                            </div>
                        </div>
                    </React.Fragment>
                ))}

                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", marginTop: 8 }}>
                    <div style={{ width: 30 }} />
                    {rows.map((row) => (
                        <div
                            key={`bottom-${row.RowNumber}`}
                            style={{
                                width: 30,
                                height: 30,
                                margin: "4px",
                                textAlign: "center",
                                fontWeight: "600",
                            }}
                        >
                            {row.RowNumber}
                        </div>
                    ))}
                    <div style={{ width: 30 }} />
                </div>
            </div>
        );
    };

    return (
        <Tabs
            className="meal-tabs"
            type="card"
            defaultActiveKey="0"
            tabBarExtraContent={
                <button
                    style={{ background: "transparent", border: "none" }}
                    onClick={skipSeats}
                    className="btn btn-light text-danger"
                >
                    <b>Skip Seats</b>
                </button>
            }
        >
            {Object.entries(rowsByFlight).map(([flightKey, rows], idx) => (
                <TabPane
                    tab={
                        <>
                            <div className="mb-0 w-100">
                                <div className="card-body p-2">
                                    <div className="d-flex justify-content-start">
                                        <div className="d-end fl-title ps-2">
                                            <div className="fw-bold">
                                                {flightKey}
                                            </div>
                                            <div className="text-sm">
                                                <span className="text-danger fw-bold">
                                                    {(selectedSeats[flightKey] || []).length}
                                                </span>{" "}
                                                of {totalSelectedTravellers} Seats selected
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                    key={idx}

                >
                    <Row>
                        <Col md={6}>
                            <div className="mt-2">
                                <h4 className="mb-1">Seat Types and Prices</h4>
                                <div
                                    className="legend-box p-3 rounded"
                                    style={{ background: "#f8feff" }}
                                >
                                    {legends[flightKey]?.legend?.map((item, index) => (
                                        <div
                                            key={index}
                                            className="d-flex align-items-center mb-2"
                                        >
                                            <div
                                                className="legend-color me-2"
                                                style={{
                                                    width: "28px",
                                                    height: "28px",
                                                    border: "1px solid #ccc",
                                                    borderRadius: "10px 10px 4px 4px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    backgroundColor: item.color || "#fff",
                                                    fontSize: "12px",
                                                    fontWeight: "600",
                                                    color: "#000",
                                                }}
                                            >
                                                {item.label === "No Seat" && <FaTimes style={{ color: "#fff", fontSize: "20px" }} />}
                                            </div>
                                            <span>
                                                {item.label}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </Col>

                        <Col md={18}>
                            <div className="overflow-auto">
                                <div className="aircraft">
                                    <div className="aircraft-body">

                                        <div className="aircraft-head">
                                            <div className="aircraft-head-body">
                                                <div className="windows">
                                                    <img loading="lazy" src="https://i.ibb.co/F5hp29L/windows.png" alt="Aircraft windows" />
                                                </div>
                                            </div>

                                        </div>

                                        <div className="Airline_starting">
                                            <div className="kitchen1">
                                                <svg width={25} xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#666666" version="1.1" id="Capa_1" viewBox="0 0 470.002 470.002" xml:space="preserve" lang="en">
                                                    <g>
                                                        <rect x="182.751" y="331.58" width="104.5" height="88"/>
                                                        <g>
                                                            <path d="M452.002,232.955h-97.833v228.999h97.833c9.925,0,18-8.075,18-18V250.955C470.002,241.03,461.927,232.955,452.002,232.955    z"/>
                                                            <path d="M18,461.955h101.167V232.955H18c-9.925,0-18,8.075-18,18v192.999C0,453.88,8.075,461.955,18,461.955z"/>
                                                        </g>
                                                        <path d="M139.167,232.955v228.999h195.003V232.955H139.167z M290.002,266.086c5.385,0,9.75,4.365,9.75,9.75   c0,5.385-4.365,9.75-9.75,9.75s-9.75-4.365-9.75-9.75C280.252,270.451,284.618,266.086,290.002,266.086z M253.336,266.086   c5.384,0,9.749,4.365,9.749,9.75c0,5.385-4.365,9.75-9.749,9.75c-5.387,0-9.753-4.365-9.753-9.75   C243.584,270.451,247.95,266.086,253.336,266.086z M216.67,266.086c5.384,0,9.749,4.365,9.749,9.75c0,5.385-4.365,9.75-9.749,9.75   c-5.387,0-9.754-4.365-9.754-9.75C206.917,270.451,211.284,266.086,216.67,266.086z M180,266.086c5.385,0,9.75,4.365,9.75,9.75   c0,5.385-4.365,9.75-9.75,9.75c-5.385,0-9.75-4.365-9.75-9.75C170.25,270.451,174.615,266.086,180,266.086z M307.251,429.58   c0,5.523-4.478,10-10,10h-124.5c-5.523,0-10-4.477-10-10v-108c0-5.523,4.477-10,10-10h124.5c5.522,0,10,4.477,10,10V429.58z"/>
                                                    </g>
                                                    <path d="M270.045,114.927c-6.155,0-11.191-5.036-11.191-11.191V19.239c0-6.155-5.036-11.191-11.192-11.191h-25.32  c-6.156,0-11.192,5.036-11.192,11.191v84.497c0,6.155-5.036,11.191-11.191,11.191h-43.297c-6.156,0-11.192,5.036-11.192,11.191  v21.63c0,6.155,5.036,11.191,11.192,11.191h156.682c6.155,0,11.192-5.036,11.192-11.191v-21.63c0-6.155-5.037-11.191-11.192-11.191  H270.045z"/>
                                                </svg>
                                                <br /> Kitchen
                                            </div>
                                            <div className="hostes1">
                                                <div className="hostes"><img src="https://www.svgrepo.com/show/86230/crew.svg" alt="crew member" /></div>
                                                <div className="hostes"><img src="https://www.svgrepo.com/show/86230/crew.svg" alt="crew member" /></div>
                                            </div>
                                        </div>

                                        <div className="Exit">
                                            <div className="Exit_door top">Exit</div>
                                            <div className="Exit_door bottom">Exit</div>
                                        </div>

                                        {renderSeatSection(rows, flightKey)}
                                        <div className="Exit">
                                            <div className="Exit_door top">Exit</div>
                                            <div className="Exit_door bottom">Exit</div>
                                        </div>

                                        <div className="aircraft-top-wing">
                                            <div className="exists">
                                                <div>
                                                    <svg width="64px" height="64px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M5 19L11.2929 12.7071C11.6830 12.3166 12.3166 12.3166 12.7071 12.7071L19 19" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                                                        <path d="M5 11L11.2929 4.70711C11.6830 4.31658 12.3166 4.31658 12.7071 4.70711L19 11" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                                                    </svg>
                                                </div>
                                                <div>
                                                    <svg width="64px" height="64px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M5 19L11.2929 12.7071C11.6830 12.3166 12.3166 12.3166 12.7071 12.7071L19 19" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                                                        <path d="M5 11L11.2929 4.70711C11.6830 4.31658 12.3166 4.31658 12.7071 4.70711L19 11" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="Airline_ending">
                                            <div className="kitchen1">
                                                <svg width={25} xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#666666" version="1.1" id="Capa_1" viewBox="0 0 470.002 470.002" xml:space="preserve" lang="en">
                                                    <g>
                                                        <rect x="182.751" y="331.58" width="104.5" height="88"/>
                                                        <g>
                                                            <path d="M452.002,232.955h-97.833v228.999h97.833c9.925,0,18-8.075,18-18V250.955C470.002,241.03,461.927,232.955,452.002,232.955    z"/>
                                                            <path d="M18,461.955h101.167V232.955H18c-9.925,0-18,8.075-18,18v192.999C0,453.88,8.075,461.955,18,461.955z"/>
                                                        </g>
                                                        <path d="M139.167,232.955v228.999h195.003V232.955H139.167z M290.002,266.086c5.385,0,9.75,4.365,9.75,9.75   c0,5.385-4.365,9.75-9.75,9.75s-9.75-4.365-9.75-9.75C280.252,270.451,284.618,266.086,290.002,266.086z M253.336,266.086   c5.384,0,9.749,4.365,9.749,9.75c0,5.385-4.365,9.75-9.749,9.75c-5.387,0-9.753-4.365-9.753-9.75   C243.584,270.451,247.95,266.086,253.336,266.086z M216.67,266.086c5.384,0,9.749,4.365,9.749,9.75c0,5.385-4.365,9.75-9.749,9.75   c-5.387,0-9.754-4.365-9.754-9.75C206.917,270.451,211.284,266.086,216.67,266.086z M180,266.086c5.385,0,9.75,4.365,9.75,9.75   c0,5.385-4.365,9.75-9.75,9.75c-5.385,0-9.75-4.365-9.75-9.75C170.25,270.451,174.615,266.086,180,266.086z M307.251,429.58   c0,5.523-4.478,10-10,10h-124.5c-5.523,0-10-4.477-10-10v-108c0-5.523,4.477-10,10-10h124.5c5.522,0,10,4.477,10,10V429.58z"/>
                                                    </g>
                                                    <path d="M270.045,114.927c-6.155,0-11.191-5.036-11.191-11.191V19.239c0-6.155-5.036-11.191-11.192-11.191h-25.32  c-6.156,0-11.192,5.036-11.192,11.191v84.497c0,6.155-5.036,11.191-11.191,11.191h-43.297c-6.156,0-11.192,5.036-11.192,11.191  v21.63c0,6.155,5.036,11.191,11.192,11.191h156.682c6.155,0,11.192-5.036,11.192-11.191v-21.63c0-6.155-5.037-11.191-11.192-11.191  H270.045z"/>
                                                </svg>
                                                <br /> Kitchen
                                            </div>
                                            <div className="hostes1">
                                                <div className="hostes"><img src="https://www.svgrepo.com/show/86230/crew.svg" alt="crew member" /></div>
                                                <div className="hostes"><img src="https://www.svgrepo.com/show/86230/crew.svg" alt="crew member" /></div>
                                            </div>
                                        </div>

                                        <div className="aircraft-back"></div>

                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </TabPane>
            ))}
        </Tabs>
    );
};
export default AirplaneSeat;